// import React, { useState, useEffect } from 'react';
// import { Modal } from 'react-bootstrap';
// import {
//   FaPlus,
//   FaEdit,
//   FaTrash,
//   FaEye,
//   FaEyeSlash,
//   FaShoppingBag,
//   FaDollarSign,
//   FaSearch,
//   FaThLarge,
//   FaList,
//   FaCog,
//   FaBoxes,
//   FaImage,
//   FaSpinner,
//   FaMapMarkerAlt,
//   FaCalendarAlt,
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import './readyproducts.scss';
// import FurnitureNavbar from '../../../../components/layout/Nav';
// import withAuth from '../../../auth/WithAuth';
// import { serverUrlAuth } from '../../../../serverUrl';

// const ArtisanReadyProducts = () => {
//   const [viewMode, setViewMode] = useState('grid');
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [productToDelete, setProductToDelete] = useState(null);
//   const [products, setProducts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [actionLoading, setActionLoading] = useState({
//     add: false,
//     edit: false,
//     delete: false,
//     toggleStatus: false,
//   });
//   const [shopStats, setShopStats] = useState({
//     totalProducts: 0,
//     activeProducts: 0,
//     totalSales: 0,
//     totalRevenue: 0,
//     lowStock: 0,
//     outOfStock: 0,
//   });

//   const [newProduct, setNewProduct] = useState({
//     name: '',
//     description: '',
//     price: '',
//     stock: '1',
//     location: '',
//     is_available: true,
//     images: [],
//     category: 'furniture',
//   });

//   const [editProduct, setEditProduct] = useState({
//     name: '',
//     description: '',
//     price: '',
//     stock: '',

//     // is_available: true,
//   });

//   useEffect(() => {
//     fetchProducts();
//   }, []);

//   useEffect(() => {
//     if (products.length > 0) {
//       calculateShopStats();
//     }
//   }, [products]);

//   const fetchProducts = async () => {
//     try {
//       setLoading(true);
//       const response = await serverUrlAuth.get('projects/ready-made-products/');
//       setProducts(response.data);
//     } catch (error) {
//       console.error('Error fetching products:', error);
//       toast.error('Failed to load products');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const calculateShopStats = () => {
//     const stats = {
//       totalProducts: products.length,
//       activeProducts: products.filter((p) => p.is_available).length,
//       totalSales: products.reduce((sum, p) => sum + (p.sold_count || 0), 0),
//       totalRevenue: products.reduce(
//         (sum, p) => sum + parseFloat(p.price) * (p.sold_count || 0),
//         0,
//       ),
//       lowStock: products.filter((p) => p.stock > 0 && p.stock <= 5).length,
//       outOfStock: products.filter((p) => p.stock === 0).length,
//     };
//     setShopStats(stats);
//   };

//   // Filter products
//   const filteredProducts = products.filter((product) => {
//     const matchesSearch =
//       product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       product.description?.toLowerCase().includes(searchTerm.toLowerCase());

//     const matchesStatus =
//       filterStatus === 'all'
//         ? true
//         : filterStatus === 'active'
//           ? product.is_available
//           : filterStatus === 'inactive'
//             ? !product.is_available
//             : true;

//     return matchesSearch && matchesStatus;
//   });

//   const handleAddProduct = async () => {
//     if (!newProduct.name || !newProduct.price) {
//       toast.error('Please fill in all required fields');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('name', newProduct.name);
//     formData.append('description', newProduct.description || '');
//     formData.append('price', newProduct.price);
//     formData.append('stock', newProduct.stock || '1');
//     formData.append('location', newProduct.location || '');
//     formData.append('is_available', newProduct.is_available ? 'true' : 'false');
//     formData.append('category', newProduct.category || 'furniture');

//     if (newProduct.images && newProduct.images.length > 0) {
//       Array.from(newProduct.images).forEach((file) => {
//         formData.append('images', file);
//       });
//     }

//     try {
//       setActionLoading((prev) => ({ ...prev, add: true }));
//       const response = await serverUrlAuth.post(
//         'projects/ready-made-products/',
//         formData,
//       );
//       setProducts([...products, response.data]);
//       setShowAddModal(false);
//       resetNewProductForm();
//       toast.success('Product added successfully');
//     } catch (error) {
//       console.error('Error adding product:', error);
//       toast.error(error.response?.data?.message || 'Failed to add product');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, add: false }));
//     }
//   };

//   const handleEditClick = (product) => {
//     setSelectedProduct(product);
//     setEditProduct({
//       name: product.name,
//       description: product.description,
//       price: product.price,
//       stock: product.stock,
//       // is_available: product.is_available,
//     });
//     setShowEditModal(true);
//   };

//   const handleUpdateProduct = async () => {
//     if (!selectedProduct) return;

//     try {
//       setActionLoading((prev) => ({ ...prev, edit: true }));
//       const response = await serverUrlAuth.patch(
//         `projects/ready-made-products/${selectedProduct.id}/`,
//         editProduct,
//       );
//       setProducts(
//         products.map((p) => (p.id === selectedProduct.id ? response.data : p)),
//       );
//       setShowEditModal(false);
//       toast.success('Product updated successfully');
//     } catch (error) {
//       console.error('Error updating product:', error);
//       toast.error('Failed to update product');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, edit: false }));
//     }
//   };

//   const handleDeleteClick = (product) => {
//     setProductToDelete(product);
//     setShowDeleteModal(true);
//   };

//   const handleDeleteProduct = async () => {
//     if (!productToDelete) return;

//     try {
//       setActionLoading((prev) => ({ ...prev, delete: true }));
//       await serverUrlAuth.delete(
//         `projects/ready-made-products/${productToDelete.id}/`,
//       );
//       setProducts(products.filter((p) => p.id !== productToDelete.id));
//       setShowDeleteModal(false);
//       setProductToDelete(null);
//       toast.success('Product deleted successfully');
//     } catch (error) {
//       console.error('Error deleting product:', error);
//       toast.error('Failed to delete product');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, delete: false }));
//     }
//   };

//   const handleToggleStatus = async (productId) => {
//     const product = products.find((p) => p.id === productId);
//     try {
//       setActionLoading((prev) => ({ ...prev, toggleStatus: true }));
//       const response = await serverUrlAuth.patch(
//         `projects/ready-made-products/${productId}/`,
//         { is_available: !product.is_available },
//       );
//       setProducts(
//         products.map((p) =>
//           p.id === productId
//             ? { ...p, is_available: response.data.is_available }
//             : p,
//         ),
//       );
//       toast.success(
//         `Product ${response.data.is_available ? 'activated' : 'deactivated'}`,
//       );
//     } catch (error) {
//       console.error('Error toggling product status:', error);
//       toast.error('Failed to update product status');
//     } finally {
//       setActionLoading((prev) => ({ ...prev, toggleStatus: false }));
//     }
//   };

//   const handleImageUpload = (e) => {
//     const files = Array.from(e.target.files);
//     setNewProduct({ ...newProduct, images: files });
//   };

//   const resetNewProductForm = () => {
//     setNewProduct({
//       name: '',
//       description: '',
//       price: '',
//       stock: '1',
//       location: '',
//       // is_available: true,
//       images: [],
//     });
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//     });
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="loading-spinner">
//           <FaSpinner className="spinner" />
//           <p>Loading products...</p>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="artisan-ready-products">
//         <div className="products-container">
//           {/* Header */}
//           <div className="products-header">
//             <div className="header-left">
//               <h1>Ready-Made Products</h1>
//             </div>
//             <div className="header-actions">
//               <button
//                 className="add-product-btn"
//                 onClick={() => setShowAddModal(true)}
//               >
//                 <FaPlus /> Add New Product
//               </button>
//             </div>
//           </div>

//           {/* Stats Cards */}
//           <div className="shop-stats">
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaBoxes />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">{shopStats.totalProducts}</div>
//                 <div className="stat-label">Total Products</div>
//               </div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaEye />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">{shopStats.activeProducts}</div>
//                 <div className="stat-label">Products In Stock</div>
//               </div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaShoppingBag />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">{shopStats.totalSales}</div>
//                 <div className="stat-label">Units Sold</div>
//               </div>
//             </div>
//             <div className="stat-card">
//               <div className="stat-icon">
//                 <FaDollarSign />
//               </div>
//               <div className="stat-info">
//                 <div className="stat-value">
//                   KSh {shopStats.totalRevenue.toLocaleString()}
//                 </div>
//                 <div className="stat-label">Total Revenue</div>
//               </div>
//             </div>
//           </div>

//           {/* Filters Bar */}
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch />
//               <input
//                 type="text"
//                 placeholder="Search products..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//               />
//             </div>
//             <div className="filter-actions">
//               <select
//                 className="filter-select"
//                 value={filterStatus}
//                 onChange={(e) => setFilterStatus(e.target.value)}
//               >
//                 <option value="all">All Status</option>
//                 <option value="active">Available</option>
//                 <option value="inactive">Unavailable</option>
//               </select>
//               <div className="view-toggle">
//                 <button
//                   className={viewMode === 'grid' ? 'active' : ''}
//                   onClick={() => setViewMode('grid')}
//                 >
//                   <FaThLarge />
//                 </button>
//                 <button
//                   className={viewMode === 'list' ? 'active' : ''}
//                   onClick={() => setViewMode('list')}
//                 >
//                   <FaList />
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Products Display */}
//           {filteredProducts.length === 0 ? (
//             <div className="empty-state">
//               <div className="empty-icon">
//                 <FaBoxes />
//               </div>
//               <h2>No products found</h2>
//               <p>
//                 Get started by adding your first ready-made product to your shop
//               </p>
//               <button
//                 className="add-first-btn"
//                 onClick={() => setShowAddModal(true)}
//               >
//                 <FaPlus /> Add Your First Product
//               </button>
//             </div>
//           ) : (
//             <div
//               className={`products-grid ${viewMode === 'list' ? 'list-view' : ''}`}
//             >
//               {filteredProducts.map((product) => (
//                 <div key={product.id} className="product-card">
//                   <div className="product-image">
//                     {product.images && product.images.length > 0 ? (
//                       <img
//                         src={product.images[0].image || product.images[0]}
//                         alt={product.name}
//                       />
//                     ) : (
//                       <div className="image-placeholder">
//                         <FaImage />
//                       </div>
//                     )}
//                     {product.stock === 0 && (
//                       <div className="stock-overlay">Out of Stock</div>
//                     )}
//                     {product.stock > 0 && product.stock <= 2 && (
//                       <div className="stock-overlay low-stock">
//                         Low Stock: {product.stock} left
//                       </div>
//                     )}
//                   </div>
//                   <div className="product-info">
//                     <h3 className="product-name">{product.name}</h3>
//                     <div className="product-price">
//                       KSh {parseFloat(product.price).toLocaleString()}
//                     </div>
//                     <div className="product-stats">
//                       <span>
//                         <FaCalendarAlt /> {formatDate(product.created_at)}
//                       </span>
//                       <span>
//                         <FaBoxes /> Stock: {product.stock}
//                       </span>
//                     </div>
//                     <p className="product-description">{product.description}</p>
//                   </div>
//                   <div className="product-actions">
//                     <button
//                       className="edit-btn"
//                       onClick={() => handleEditClick(product)}
//                       disabled={actionLoading.edit}
//                     >
//                       <FaEdit /> Edit
//                     </button>
//                     <button
//                       className="edit-btn delete-btn"
//                       onClick={() => handleDeleteClick(product)}
//                       disabled={actionLoading.delete}
//                     >
//                       {actionLoading.delete ? (
//                         <FaSpinner className="spinner" />
//                       ) : (
//                         <FaTrash />
//                       )}{' '}
//                       Delete
//                     </button>
//                     <button
//                       className={`toggle-btn ${product.is_available ? '' : 'inactive'}`}
//                       onClick={() => handleToggleStatus(product.id)}
//                       disabled={actionLoading.toggleStatus}
//                     >
//                       {product.is_available ? 'In Stock' : 'Out of Stock'}
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Add Product Modal */}
//         <Modal
//           show={showAddModal}
//           onHide={() => {
//             setShowAddModal(false);
//             resetNewProductForm();
//           }}
//           size="xl"
//           centered
//           className="add-product-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Add New Product</h2>
//           </Modal.Header>
//           <Modal.Body>
//             <div className="modal-flex-container">
//               <div className="form-column">
//                 <div className="form-section">
//                   <div className="form-group">
//                     <label>
//                       Product Name <span className="required">*</span>
//                     </label>
//                     <input
//                       type="text"
//                       value={newProduct.name}
//                       onChange={(e) =>
//                         setNewProduct({ ...newProduct, name: e.target.value })
//                       }
//                       placeholder="e.g., Modern Wooden Chair"
//                       required
//                     />
//                   </div>
//                   <div className="form-group">
//                     <label>Description</label>
//                     <textarea
//                       value={newProduct.description}
//                       onChange={(e) =>
//                         setNewProduct({
//                           ...newProduct,
//                           description: e.target.value,
//                         })
//                       }
//                       placeholder="Describe your product..."
//                       rows="4"
//                     />
//                   </div>
//                   <div className="form-row">
//                     <div className="form-group">
//                       <label>
//                         Stock Quantity <span className="required">*</span>
//                       </label>
//                       <input
//                         type="number"
//                         value={newProduct.stock}
//                         onChange={(e) =>
//                           setNewProduct({
//                             ...newProduct,
//                             stock: e.target.value,
//                           })
//                         }
//                         placeholder="e.g., 10"
//                         min="0"
//                         required
//                       />
//                     </div>
//                     <div className="form-group">
//                       <label>
//                         Price (KSh) <span className="required">*</span>
//                       </label>
//                       <input
//                         type="number"
//                         value={newProduct.price}
//                         onChange={(e) =>
//                           setNewProduct({
//                             ...newProduct,
//                             price: e.target.value,
//                           })
//                         }
//                         placeholder="e.g., 12999"
//                         min="0"
//                         step="0.01"
//                         required
//                       />
//                     </div>
//                   </div>
//                   <div className="form-group">
//                     <label>Location</label>
//                     <input
//                       type="text"
//                       value={newProduct.location}
//                       onChange={(e) =>
//                         setNewProduct({
//                           ...newProduct,
//                           location: e.target.value,
//                         })
//                       }
//                       placeholder="e.g., Nairobi, Kenya"
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div className="image-column">
//                 <div className="form-section">
//                   <h3>Product Images</h3>
//                   <div className="image-upload-area">
//                     <input
//                       type="file"
//                       id="image-upload"
//                       multiple
//                       accept="image/*"
//                       onChange={handleImageUpload}
//                       style={{ display: 'none' }}
//                     />
//                     <label
//                       htmlFor="image-upload"
//                       className="image-upload-label"
//                     >
//                       <FaImage />
//                       <p>Click to upload images</p>
//                       <small>PNG, JPG up to 5MB</small>
//                     </label>
//                   </div>
//                   {newProduct.images.length > 0 && (
//                     <div className="image-preview-grid">
//                       <h4>Selected Images ({newProduct.images.length})</h4>
//                       <div className="preview-container">
//                         {Array.from(newProduct.images).map((file, index) => (
//                           <div key={index} className="preview-item">
//                             <img
//                               src={URL.createObjectURL(file)}
//                               alt={`Preview ${index + 1}`}
//                               className="preview-image"
//                             />
//                             <button
//                               type="button"
//                               className="remove-image"
//                               onClick={() => {
//                                 const newImages = Array.from(
//                                   newProduct.images,
//                                 ).filter((_, i) => i !== index);
//                                 setNewProduct({
//                                   ...newProduct,
//                                   images: newImages,
//                                 });
//                               }}
//                             >
//                               ×
//                             </button>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => {
//                 setShowAddModal(false);
//                 resetNewProductForm();
//               }}
//               disabled={actionLoading.add}
//             >
//               Cancel
//             </button>
//             <button
//               className="btn btn-primary"
//               onClick={handleAddProduct}
//               disabled={actionLoading.add}
//             >
//               {actionLoading.add ? (
//                 <>
//                   <FaSpinner className="spinner" /> Adding...
//                 </>
//               ) : (
//                 <>
//                   <FaPlus /> Add Product
//                 </>
//               )}
//             </button>
//           </Modal.Footer>
//         </Modal>

//         {/* Edit Product Modal */}
//         <Modal
//           show={showEditModal}
//           onHide={() => setShowEditModal(false)}
//           centered
//           className="quick-edit-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Edit Product</h2>
//           </Modal.Header>
//           <Modal.Body>
//             {selectedProduct && (
//               <>
//                 <div className="form-group">
//                   <label>Product Name</label>
//                   <input
//                     type="text"
//                     value={editProduct.name}
//                     onChange={(e) =>
//                       setEditProduct({ ...editProduct, name: e.target.value })
//                     }
//                     placeholder="Product name"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Description</label>
//                   <textarea
//                     value={editProduct.description}
//                     onChange={(e) =>
//                       setEditProduct({
//                         ...editProduct,
//                         description: e.target.value,
//                       })
//                     }
//                     placeholder="Product description"
//                     rows="3"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Price (KSh)</label>
//                   <input
//                     type="number"
//                     value={editProduct.price}
//                     onChange={(e) =>
//                       setEditProduct({ ...editProduct, price: e.target.value })
//                     }
//                     placeholder="Price"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//                 <div className="form-group">
//                   <label>Stock Quantity</label>
//                   <div className="stock-control">
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setEditProduct({
//                           ...editProduct,
//                           stock: Math.max(
//                             0,
//                             parseInt(editProduct.stock || 0) - 1,
//                           ),
//                         })
//                       }
//                     >
//                       -
//                     </button>
//                     <input
//                       type="number"
//                       value={editProduct.stock}
//                       onChange={(e) =>
//                         setEditProduct({
//                           ...editProduct,
//                           stock: e.target.value,
//                         })
//                       }
//                       min="0"
//                     />
//                     <button
//                       type="button"
//                       onClick={() =>
//                         setEditProduct({
//                           ...editProduct,
//                           stock: parseInt(editProduct.stock || 0) + 1,
//                         })
//                       }
//                     >
//                       +
//                     </button>
//                   </div>
//                 </div>

//                 {/* <div className="form-group">
//                   <label
//                     style={{
//                       display: 'flex',
//                       alignItems: 'center',
//                       gap: '0.5rem',
//                     }}
//                   >
//                     <input
//                       type="checkbox"
//                       checked={editProduct.is_available}
//                       onChange={(e) =>
//                         setEditProduct({
//                           ...editProduct,
//                           is_available: e.target.checked,
//                         })
//                       }
//                     />
//                     Available for sale
//                   </label>
//                 </div> */}
//               </>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => setShowEditModal(false)}
//               disabled={actionLoading.edit}
//             >
//               Cancel
//             </button>
//             <button
//               className="btn btn-primary"
//               onClick={handleUpdateProduct}
//               disabled={actionLoading.edit}
//             >
//               {actionLoading.edit ? (
//                 <>
//                   <FaSpinner className="spinner" /> Saving...
//                 </>
//               ) : (
//                 'Save Changes'
//               )}
//             </button>
//           </Modal.Footer>
//         </Modal>

//         {/* Delete Confirmation Modal */}
//         <Modal
//           show={showDeleteModal}
//           onHide={() => setShowDeleteModal(false)}
//           centered
//           className="delete-modal"
//         >
//           <Modal.Header closeButton>
//             <h2>Delete Product</h2>
//           </Modal.Header>
//           <Modal.Body>
//             {productToDelete && (
//               <p>
//                 Are you sure you want to delete{' '}
//                 <strong>"{productToDelete.name}"</strong>? This action cannot be
//                 undone.
//               </p>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <button
//               className="btn btn-secondary"
//               onClick={() => setShowDeleteModal(false)}
//               disabled={actionLoading.delete}
//             >
//               Cancel
//             </button>
//             <button
//               className="btn btn-danger"
//               onClick={handleDeleteProduct}
//               disabled={actionLoading.delete}
//             >
//               {actionLoading.delete ? (
//                 <>
//                   <FaSpinner className="spinner" /> Deleting...
//                 </>
//               ) : (
//                 'Delete Product'
//               )}
//             </button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanReadyProducts, 'artisan', true);


import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import {
  FaPlus,
  FaEdit,
  FaTrash,
  FaEye,
  FaEyeSlash,
  FaShoppingBag,
  FaDollarSign,
  FaSearch,
  FaThLarge,
  FaList,
  FaCog,
  FaBoxes,
  FaImage,
  FaSpinner,
  FaMapMarkerAlt,
  FaCalendarAlt,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import './readyproducts.scss';
import FurnitureNavbar from '../../../../components/layout/Nav';
import withAuth from '../../../auth/WithAuth';
import { serverUrlAuth } from '../../../../serverUrl';

const ArtisanReadyProducts = () => {
  const [viewMode, setViewMode] = useState('grid');
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productToDelete, setProductToDelete] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState({
    add: false,
    edit: false,
    delete: false,
    toggleStatus: false,
  });
  const [shopStats, setShopStats] = useState({
    totalProducts: 0,
    activeProducts: 0,
    totalSales: 0,
    totalRevenue: 0,
    lowStock: 0,
    outOfStock: 0,
  });

  const [newProduct, setNewProduct] = useState({
    name: '',
    description: '',
    price: '',
    stock: '1',
    location: '',
    is_available: true,
    images: [],
    category: 'furniture',
  });

  const [editProduct, setEditProduct] = useState({
    name: '',
    description: '',
    price: '',
    stock: '',
  });

  useEffect(() => {
    fetchProducts();
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      calculateShopStats();
    }
  }, [products]);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await serverUrlAuth.get('projects/ready-made-products/');
      setProducts(response.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  const calculateShopStats = () => {
    const stats = {
      totalProducts: products.length,
      activeProducts: products.filter((p) => p.is_available).length,
      totalSales: products.reduce((sum, p) => sum + (p.sold_count || 0), 0),
      totalRevenue: products.reduce(
        (sum, p) => sum + parseFloat(p.price) * (p.sold_count || 0),
        0,
      ),
      lowStock: products.filter((p) => p.stock > 0 && p.stock <= 5).length,
      outOfStock: products.filter((p) => p.stock === 0).length,
    };
    setShopStats(stats);
  };

  // Filter products
  const filteredProducts = products.filter((product) => {
    const matchesSearch =
      product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      product.description?.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesStatus =
      filterStatus === 'all'
        ? true
        : filterStatus === 'active'
          ? product.is_available
          : filterStatus === 'inactive'
            ? !product.is_available
            : true;

    return matchesSearch && matchesStatus;
  });

  const handleAddProduct = async () => {
    if (!newProduct.name || !newProduct.price) {
      toast.error('Please fill in all required fields');
      return;
    }

    const formData = new FormData();
    formData.append('name', newProduct.name);
    formData.append('description', newProduct.description || '');
    formData.append('price', newProduct.price);
    formData.append('stock', newProduct.stock || '1');
    formData.append('location', newProduct.location || '');
    formData.append('is_available', newProduct.is_available ? 'true' : 'false');
    formData.append('category', newProduct.category || 'furniture');

    if (newProduct.images && newProduct.images.length > 0) {
      Array.from(newProduct.images).forEach((file) => {
        formData.append('images', file);
      });
    }

    try {
      setActionLoading((prev) => ({ ...prev, add: true }));
      const response = await serverUrlAuth.post(
        'projects/ready-made-products/',
        formData,
      );
      setProducts([...products, response.data]);
      setShowAddModal(false);
      resetNewProductForm();
      toast.success('Product added successfully');
    } catch (error) {
      console.error('Error adding product:', error);
      toast.error(error.response?.data?.message || 'Failed to add product');
    } finally {
      setActionLoading((prev) => ({ ...prev, add: false }));
    }
  };

  const handleEditClick = (product) => {
    setSelectedProduct(product);
    setEditProduct({
      name: product.name,
      description: product.description,
      price: product.price,
      stock: product.stock,
    });
    setShowEditModal(true);
  };

  const handleUpdateProduct = async () => {
    if (!selectedProduct) return;

    try {
      setActionLoading((prev) => ({ ...prev, edit: true }));
      const response = await serverUrlAuth.patch(
        `projects/ready-made-products/${selectedProduct.id}/`,
        editProduct,
      );
      setProducts(
        products.map((p) => (p.id === selectedProduct.id ? response.data : p)),
      );
      setShowEditModal(false);
      toast.success('Product updated successfully');
    } catch (error) {
      console.error('Error updating product:', error);
      toast.error('Failed to update product');
    } finally {
      setActionLoading((prev) => ({ ...prev, edit: false }));
    }
  };

  const handleDeleteClick = (product) => {
    setProductToDelete(product);
    setShowDeleteModal(true);
  };

  const handleDeleteProduct = async () => {
    if (!productToDelete) return;

    try {
      setActionLoading((prev) => ({ ...prev, delete: true }));
      await serverUrlAuth.delete(
        `projects/ready-made-products/${productToDelete.id}/`,
      );
      setProducts(products.filter((p) => p.id !== productToDelete.id));
      setShowDeleteModal(false);
      setProductToDelete(null);
      toast.success('Product deleted successfully');
    } catch (error) {
      console.error('Error deleting product:', error);
      toast.error('Failed to delete product');
    } finally {
      setActionLoading((prev) => ({ ...prev, delete: false }));
    }
  };

  const handleToggleStatus = async (productId) => {
    const product = products.find((p) => p.id === productId);
    try {
      setActionLoading((prev) => ({ ...prev, toggleStatus: true }));
      const response = await serverUrlAuth.patch(
        `projects/ready-made-products/${productId}/`,
        { is_available: !product.is_available },
      );
      setProducts(
        products.map((p) =>
          p.id === productId
            ? { ...p, is_available: response.data.is_available }
            : p,
        ),
      );
      toast.success(
        `Product ${response.data.is_available ? 'activated' : 'deactivated'}`,
      );
    } catch (error) {
      console.error('Error toggling product status:', error);
      toast.error('Failed to update product status');
    } finally {
      setActionLoading((prev) => ({ ...prev, toggleStatus: false }));
    }
  };

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    setNewProduct({ ...newProduct, images: files });
  };

  const resetNewProductForm = () => {
    setNewProduct({
      name: '',
      description: '',
      price: '',
      stock: '1',
      location: '',
      is_available: true,
      images: [],
      category: 'furniture',
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  if (loading) {
    return (
      <>
        <FurnitureNavbar />
        <div className="loading-spinner">
          <FaSpinner className="spinner" />
          <p>Loading products...</p>
        </div>
      </>
    );
  }

  return (
    <>
      <FurnitureNavbar />
      <div className="artisan-ready-products">
        <div className="products-container">
          {/* Header */}
          <div className="products-header">
            <div className="header-left">
              <h1>Ready-Made Products</h1>
            </div>
            <div className="header-actions">
              <button
                className="add-product-btn"
                onClick={() => setShowAddModal(true)}
              >
                <FaPlus /> Add New Product
              </button>
            </div>
          </div>

          {/* Stats Cards */}
          <div className="shop-stats">
            <div className="stat-card">
              <div className="stat-icon">
                <FaBoxes />
              </div>
              <div className="stat-info">
                <div className="stat-value">{shopStats.totalProducts}</div>
                <div className="stat-label">Total Products</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FaEye />
              </div>
              <div className="stat-info">
                <div className="stat-value">{shopStats.activeProducts}</div>
                <div className="stat-label">Products In Stock</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FaShoppingBag />
              </div>
              <div className="stat-info">
                <div className="stat-value">{shopStats.totalSales}</div>
                <div className="stat-label">Units Sold</div>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">
                <FaDollarSign />
              </div>
              <div className="stat-info">
                <div className="stat-value">
                  KSh {shopStats.totalRevenue.toLocaleString()}
                </div>
                <div className="stat-label">Total Revenue</div>
              </div>
            </div>
          </div>

          {/* Filters Bar */}
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch />
              <input
                type="text"
                placeholder="Search products..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="filter-actions">
              <select
                className="filter-select"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="active">Available</option>
                <option value="inactive">Unavailable</option>
              </select>
              <div className="view-toggle">
                <button
                  className={viewMode === 'grid' ? 'active' : ''}
                  onClick={() => setViewMode('grid')}
                >
                  <FaThLarge />
                </button>
                <button
                  className={viewMode === 'list' ? 'active' : ''}
                  onClick={() => setViewMode('list')}
                >
                  <FaList />
                </button>
              </div>
            </div>
          </div>

          {/* Products Display */}
          {filteredProducts.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">
                <FaBoxes />
              </div>
              <h2>No products found</h2>
              <p>
                Get started by adding your first ready-made product to your shop
              </p>
              <button
                className="add-first-btn"
                onClick={() => setShowAddModal(true)}
              >
                <FaPlus /> Add Your First Product
              </button>
            </div>
          ) : (
            <div
              className={`products-grid ${viewMode === 'list' ? 'list-view' : ''}`}
            >
              {filteredProducts.map((product) => (
                <div key={product.id} className="product-card">
                  <div className="product-image">
                    {product.images && product.images.length > 0 ? (
                      <img
                        src={product.images[0].image || product.images[0]}
                        alt={product.name}
                      />
                    ) : (
                      <div className="image-placeholder">
                        <FaImage />
                      </div>
                    )}
                    {product.stock === 0 && (
                      <div className="stock-overlay">Out of Stock</div>
                    )}
                    {product.stock > 0 && product.stock <= 2 && (
                      <div className="stock-overlay low-stock">
                        Low Stock: {product.stock} left
                      </div>
                    )}
                  </div>
                  <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <div className="product-price">
                      KSh {parseFloat(product.price).toLocaleString()}
                    </div>
                    <div className="product-stats">
                      <span>
                        <FaCalendarAlt /> {formatDate(product.created_at)}
                      </span>
                      <span>
                        <FaBoxes /> Stock: {product.stock}
                      </span>
                    </div>
                    <p className="product-description">{product.description}</p>
                  </div>
                  <div className="product-actions">
                    <button
                      className="edit-btn"
                      onClick={() => handleEditClick(product)}
                      disabled={actionLoading.edit}
                    >
                      <FaEdit /> Edit
                    </button>
                    <button
                      className="edit-btn delete-btn"
                      onClick={() => handleDeleteClick(product)}
                      disabled={actionLoading.delete}
                    >
                      {actionLoading.delete ? (
                        <FaSpinner className="spinner" />
                      ) : (
                        <FaTrash />
                      )}{' '}
                      Delete
                    </button>
                    <button
                      className={`toggle-btn ${product.is_available ? '' : 'inactive'}`}
                      onClick={() => handleToggleStatus(product.id)}
                      disabled={actionLoading.toggleStatus}
                    >
                      {product.is_available ? 'Mark Out of Stock' : 'Mark In Stock'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Add Product Modal */}
        <Modal
          show={showAddModal}
          onHide={() => {
            setShowAddModal(false);
            resetNewProductForm();
          }}
          size="xl"
          centered
          className="add-product-modal"
        >
          <Modal.Header closeButton>
            <h2>Add New Product</h2>
          </Modal.Header>
          <Modal.Body>
            <div className="modal-flex-container">
              <div className="form-column">
                <div className="form-section">
                  <div className="form-group">
                    <label>
                      Product Name <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      value={newProduct.name}
                      onChange={(e) =>
                        setNewProduct({ ...newProduct, name: e.target.value })
                      }
                      placeholder="e.g., Modern Wooden Chair"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Description</label>
                    <textarea
                      value={newProduct.description}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          description: e.target.value,
                        })
                      }
                      placeholder="Describe your product..."
                      rows="4"
                    />
                  </div>
                  <div className="form-row">
                    <div className="form-group">
                      <label>
                        Stock Quantity <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        value={newProduct.stock}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            stock: e.target.value,
                          })
                        }
                        placeholder="e.g., 10"
                        min="0"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        Price (KSh) <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        value={newProduct.price}
                        onChange={(e) =>
                          setNewProduct({
                            ...newProduct,
                            price: e.target.value,
                          })
                        }
                        placeholder="e.g., 12999"
                        min="0"
                        step="0.01"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label>Location</label>
                    <input
                      type="text"
                      value={newProduct.location}
                      onChange={(e) =>
                        setNewProduct({
                          ...newProduct,
                          location: e.target.value,
                        })
                      }
                      placeholder="e.g., Nairobi, Kenya"
                    />
                  </div>
                </div>
              </div>
              <div className="image-column">
                <div className="form-section">
                  <h3>Product Images</h3>
                  <div className="image-upload-area">
                    <input
                      type="file"
                      id="image-upload"
                      multiple
                      accept="image/*"
                      onChange={handleImageUpload}
                      style={{ display: 'none' }}
                    />
                    <label
                      htmlFor="image-upload"
                      className="image-upload-label"
                    >
                      <FaImage />
                      <p>Click to upload images</p>
                      <small>PNG, JPG up to 5MB</small>
                    </label>
                  </div>
                  {newProduct.images.length > 0 && (
                    <div className="image-preview-grid">
                      <h4>Selected Images ({newProduct.images.length})</h4>
                      <div className="preview-container">
                        {Array.from(newProduct.images).map((file, index) => (
                          <div key={index} className="preview-item">
                            <img
                              src={URL.createObjectURL(file)}
                              alt={`Preview ${index + 1}`}
                              className="preview-image"
                            />
                            <button
                              type="button"
                              className="remove-image"
                              onClick={() => {
                                const newImages = Array.from(
                                  newProduct.images,
                                ).filter((_, i) => i !== index);
                                setNewProduct({
                                  ...newProduct,
                                  images: newImages,
                                });
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => {
                setShowAddModal(false);
                resetNewProductForm();
              }}
              disabled={actionLoading.add}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleAddProduct}
              disabled={actionLoading.add}
            >
              {actionLoading.add ? (
                <>
                  <FaSpinner className="spinner" /> Adding...
                </>
              ) : (
                <>
                  <FaPlus /> Add Product
                </>
              )}
            </button>
          </Modal.Footer>
        </Modal>

        {/* Edit Product Modal */}
        <Modal
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          centered
          className="quick-edit-modal"
        >
          <Modal.Header closeButton>
            <h2>Edit Product</h2>
          </Modal.Header>
          <Modal.Body>
            {selectedProduct && (
              <>
                <div className="form-group">
                  <label>Product Name</label>
                  <input
                    type="text"
                    value={editProduct.name}
                    onChange={(e) =>
                      setEditProduct({ ...editProduct, name: e.target.value })
                    }
                    placeholder="Product name"
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    value={editProduct.description}
                    onChange={(e) =>
                      setEditProduct({
                        ...editProduct,
                        description: e.target.value,
                      })
                    }
                    placeholder="Product description"
                    rows="3"
                  />
                </div>
                <div className="form-group">
                  <label>Price (KSh)</label>
                  <input
                    type="number"
                    value={editProduct.price}
                    onChange={(e) =>
                      setEditProduct({ ...editProduct, price: e.target.value })
                    }
                    placeholder="Price"
                    min="0"
                    step="0.01"
                  />
                </div>
                <div className="form-group">
                  <label>Stock Quantity</label>
                  <div className="stock-control">
                    <button
                      type="button"
                      onClick={() =>
                        setEditProduct({
                          ...editProduct,
                          stock: Math.max(
                            0,
                            parseInt(editProduct.stock || 0) - 1,
                          ),
                        })
                      }
                    >
                      -
                    </button>
                    <input
                      type="number"
                      value={editProduct.stock}
                      onChange={(e) =>
                        setEditProduct({
                          ...editProduct,
                          stock: e.target.value,
                        })
                      }
                      min="0"
                    />
                    <button
                      type="button"
                      onClick={() =>
                        setEditProduct({
                          ...editProduct,
                          stock: parseInt(editProduct.stock || 0) + 1,
                        })
                      }
                    >
                      +
                    </button>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => setShowEditModal(false)}
              disabled={actionLoading.edit}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleUpdateProduct}
              disabled={actionLoading.edit}
            >
              {actionLoading.edit ? (
                <>
                  <FaSpinner className="spinner" /> Saving...
                </>
              ) : (
                'Save Changes'
              )}
            </button>
          </Modal.Footer>
        </Modal>

        {/* Delete Confirmation Modal */}
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
          className="delete-modal"
        >
          <Modal.Header closeButton>
            <h2>Delete Product</h2>
          </Modal.Header>
          <Modal.Body>
            {productToDelete && (
              <p>
                Are you sure you want to delete{' '}
                <strong>"{productToDelete.name}"</strong>? This action cannot be
                undone.
              </p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={() => setShowDeleteModal(false)}
              disabled={actionLoading.delete}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger"
              onClick={handleDeleteProduct}
              disabled={actionLoading.delete}
            >
              {actionLoading.delete ? (
                <>
                  <FaSpinner className="spinner" /> Deleting...
                </>
              ) : (
                'Delete Product'
              )}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default withAuth(ArtisanReadyProducts, 'artisan');